import React from 'react';
const scrollToPricing = () => {
  document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth'
  });
};
export function SolutionIntro() {
  return <section className="w-full bg-black pt-12 md:pt-16 pb-4 md:pb-6 px-4 pl-[16px] pr-[16px]" data-id="element-346">
      <div className="max-w-2xl mx-auto text-center" data-id="element-347">
        <p className="text-yellow-400 font-bold text-lg mb-4 font-heading" data-id="element-348">
          🏆 El sistema más práctico para acompañar el comportamiento infantil
          desde casa
        </p>

        <h2 className="text-3xl md:text-5xl font-black font-heading text-white leading-tight mb-4" data-id="element-349">
          🧠 MEGAPACK
          <br data-id="element-350" />
          TDAH EN RETROCESO
        </h2>

        <p className="text-lg text-yellow-400 font-bold font-heading" data-id="element-351">
          👉 Todo listo para aplicar desde hoy
        </p>
      </div>
    </section>;
}